import { checkoutFailed, checkoutSuccess } from "../actions/checkout/actionCreators";
import { createCheckout } from "../services/checkout";

export function createCheckoutThunk(cart: Cart, user: User, shippingFee: number = 0, stock?: number) {
    return async (dispatch: any) => {
        try {
            const checkout: CheckoutTransaction = await createCheckout(cart, user, shippingFee, stock)
            window.location.href = checkout?.redirectUrl
            dispatch(checkoutSuccess())
        } catch (err) {
            dispatch(checkoutFailed())
        }
        
    }
}